import { fetchApi } from 'shared/functions';

export const fetchInvestorRelations = async () => {
  const investorRelations = await fetchApi(
    '/user-profile/portfolios/organisations/by-ultimate-issuer',
  )
    .then((response) => response.json())
    .catch((resp) => []);
  return investorRelations;
};
